import { createMemoryRouter } from 'react-router-dom'
import { createHistoryAdapter } from './helpers/historyAdapter'
import { createHistorySync } from './helpers/historySync'
import { createPathNormalizer } from './helpers/pathNormalizer'

const historyIndexKey = '__wellesleyHistoryIndex'

export const createRouter = (
  routes: Parameters<typeof createMemoryRouter>[0],
  deps: {
    historyAdapter: ReturnType<typeof createHistoryAdapter>
    pathNormalizer: ReturnType<typeof createPathNormalizer>
    historyIndexKey: string
  } = {
    historyAdapter: createHistoryAdapter(),
    pathNormalizer: createPathNormalizer(),
    historyIndexKey,
  },
) => {
  const { historyAdapter, pathNormalizer, historyIndexKey: historyKey } = deps
  const router = createMemoryRouter(routes, {
    initialEntries: [pathNormalizer.toRouterPath(historyAdapter.getLocation())],
  })
  const historySync = createHistorySync({
    historyAdapter,
    pathNormalizer,
    historyIndexKey: historyKey,
  })

  const handlePopState = (event: PopStateEvent) => {
    historySync.handlePopState(event)
    void router.navigate(
      pathNormalizer.toRouterPath(historyAdapter.getLocation()),
      {
        replace: true,
      },
    )
  }

  historyAdapter.addPopStateListener(handlePopState)

  historySync.init(router.state.location, router.state.location.key)

  const unsubscribe = router.subscribe((state) => {
    historySync.handleStateChange(state)
  })

  const cleanup = () => {
    historyAdapter.removePopStateListener(handlePopState)
    unsubscribe()
  }

  return { router, cleanup }
}
